import React from 'react';
import { ITranslateProps, translate } from '../../mixins/translate';

export interface IStatusLabelProps extends ITranslateProps {
    value?: undefined | string;
}

class StatusLabelComponent extends React.Component<IStatusLabelProps, Record<string, unknown>> {
    public override render() {
        if (!this.props.value) {
            return null;
        }
        // let name = codeToName(this.props.value);
        const text = this.props.t(`objectStatus.${this.props.value}`);
        return (
            <span className={`label ${this.statusToClassname(this.props.value)}`} title={text}>
                {text}
            </span>
        );
    }

    private statusToClassname(status: string) {
        switch (status) {
            case 'inUse':
                return 'label-success';
            case 'inMaintenance':
                return 'label-warning';
            case 'underConstruction':
                return 'label-warning';
            case 'outOfService':
                return 'label-muted';
            case 'deleted':
                return 'label-danger';
            case 'cancelled':
                return 'label-muted';
            default:
                return 'label-info';
        }
    }
}

// eslint-disable-next-line @typescript-eslint/naming-convention
const ObjectStatusLabel = translate()(StatusLabelComponent);
export { ObjectStatusLabel };
